export default __webpack_public_path__ + "static/media/sous-leau.358732e5.svg";